export default "__VITE_ASSET__$hCKqydr__"